import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import "../RepEditPage.css";
import Category from "../../components/RepEditCategories/Category.js";
import JodittEditor from "../../components/QuillEditors/JoditEditor.js";
import NavbarLogin from "../../components/navbarDashboard/NavbarDashboard.js";
import { Button } from "@mui/material";
import { Card, CardContent } from "@mui/material";
// import { Await, useFetcher } from "react-router-dom";

import {
SEMINARS_WORKSHOPS,
CONFERENCE,
FACULTY_PARTICIPATION,
BOOKS_PUBLISHED,
PATENTS_OBTAINED,
EQUIPMENTS_ADDED,
FINANCIAL_ASSISTANCE,
RESEARCH_AND_DEVELOPMENT,
LIST_OF_PAPERS_PUBLISHED,
NEW_LABORATORY_CENTER,
ReportContentContext,
} from "../../providers/reportContentProvider.js";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  height: "100%",
}));

export default function HodEdit() {
  const navigation = useNavigate();
  const { id } = useParams();
  const { title } = useParams();
  const { currentYear } = useParams();
  const { currentQuarter } = useParams();
  const handleUpdate = () => {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")} `,
      },
      body: JSON.stringify({ data: { content } }),
    };
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/report/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("put data",data);
        if(localStorage.getItem("role")==="REPRESENTATIVE"){
        navigation(`/sec/${id}/${currentYear}/${currentQuarter}`);
        }else if(localStorage.getItem("role")==="HOD"){
          navigation(`/hodEdit/${id}/${currentYear}/${currentQuarter}`);
        }
      });
  };
  const { setContent, content } = React.useContext(ReportContentContext);
  const [clickedItem, setClickedItem] = React.useState("");

  const sections = [
    { name: "Seminars and Workshops attended", key: SEMINARS_WORKSHOPS },
    { name: "Conference /Seminars /Workshops Organized", key: CONFERENCE },
    { name: "Faculty participation in GATE/NET", key: FACULTY_PARTICIPATION },
    { name: "Books/Chapters published by faculty members", key: BOOKS_PUBLISHED },
    { name: "Patents obtained", key: PATENTS_OBTAINED },
    { name: "List of equipments added during the period", key: EQUIPMENTS_ADDED },
    { name: "Financial assistance received", key: FINANCIAL_ASSISTANCE },
    { name: "R & D proposals submitted", key: RESEARCH_AND_DEVELOPMENT },
    { name: "New Laboratories / Centers Added", key: NEW_LABORATORY_CENTER },
    { name:"List of Papers Published (Count Only)", key: LIST_OF_PAPERS_PUBLISHED}
  ];

  React.useEffect(() => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/report/${currentYear}/${currentQuarter}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("Data",data);
        setContent((prevContent) => ({ ...prevContent, ...data.content }));
        console.log(title);
        setClickedItem(sections.find((section) => section?.name === title).key);
      });
  }, []);

  const handleEditorContentChange = (newContent) => {
    setContent((prevContent) => ({
      ...prevContent,
      [clickedItem]: newContent,  
    }));
  };

  return (
    <>
      <NavbarLogin />
      <Box sx={{ flexGrow: 1, marginTop: "100px", marginBottom: "5%" }}>
        <Grid container spacing={2}>
          <Grid item xs={3} columnSpacing={{ xs: 1, sm: 3, md: 3 }}>
            <Item>
              {sections.map((section) => (
                <React.Fragment key={section.key}>
                  <Category
                    key={section.key}
                    category={section.name}
                    currentlySelected={
                      section.key === clickedItem ? true : false
                    }
                    handleClick={() => setClickedItem(section.key)}
                  />
                </React.Fragment>
              ))}
            </Item>
          </Grid>
          {/* <Button
            variant="contained"
            style={{
              position: "fixed",
              bottom: 16,
              right: 500,
              color: "#ffffff",
              backgroundColor: "#035088",
            }}
          >
            Submit
          </Button> */}
          <Grid item xs={9}>
            <Item>
              <JodittEditor subTitle={clickedItem} editorContent={content[clickedItem] ? content[clickedItem] : ''} onContentChange={handleEditorContentChange}/>
            </Item>
          </Grid>
          <Card
            style={{
              position: "fixed",
              bottom: 0,
              right: 0,
              backgroundColor: "#E2EBFC", // Set your desired card background color
              width: "100%",
              height: "8%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              //opacity: "80%",
            }}
          >
            <CardContent>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#035088",
                  marginTop: "8px",
                  zIndex: 1,
                }}
                onClick={handleUpdate}
              >
                Update
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Box>
    </>
  );
}
